import script from "./reviewPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewPopup.vue?vue&type=script&setup=true&lang=js"

import "./reviewPopup.vue?vue&type=style&index=0&id=57a23f2a&lang=css"

const __exports__ = script;

export default __exports__